// Centralized data-testid constants for Alae Dental
export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  services: "nav-services",
  blog: "nav-blog",
  contact: "nav-contact",
  cta: "nav-waitlist-cta",
  mobileToggle: "nav-mobile-toggle",
  emergencyCall: "emergency-call-link",
};

// Campaign landing page callback form
export const CALLBACK = {
  form: "callback-form",
  name: "callback-name",
  phone: "callback-phone",
  email: "callback-email",
  contactMethod: (m) => `callback-contact-${m.toLowerCase()}`,
  consent: "callback-consent",
  submit: "callback-submit",
  success: "callback-success",
};

// Grand Opening promo (temporary)
export const PROMO_IDS = {
  banner: "promo-banner",
  bannerCta: "promo-banner-cta",
  bannerClose: "promo-banner-close",
  modal: "promo-modal",
  modalClose: "promo-modal-close",
  modalBook: "promo-modal-book",
  modalDetails: "promo-modal-details",
  modalNewPatient: "promo-modal-new-patient",
  homeBand: "promo-home-band",
  homeBandCta: "promo-home-band-cta",
  homeBandOffer: (i) => `promo-home-band-offer-${i}`,
  navLink: "nav-grand-opening",
  page: "grand-opening-page",
  pageBook: "grand-opening-book",
  pageAsk: "grand-opening-ask",
  pageOffer: (i) => `grand-opening-offer-${i}`,
  pageOfferBook: (i) => `grand-opening-offer-book-${i}`,
  finePrint: "grand-opening-fine-print",
  newPatientBlock: "grand-opening-new-patient",
  newPatientCta: "grand-opening-new-patient-cta",
  newPatientBook: "grand-opening-new-patient-book",
};

export const HOME = {
  heroHeadline: "hero-headline",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  philosophy: "philosophy-section",
  drMirza: "dr-mirza-section",
  drMirzaCta: "dr-mirza-cta",
  experience: "experience-section",
  servicesOverview: "services-overview",
  serviceCard: (i) => `service-card-${i}`,
  testimonials: "testimonials-section",
  blogPreview: "blog-preview-section",
  blogCard: (i) => `blog-card-${i}`,
  faq: "faq-section",
  faqItem: (i) => `faq-item-${i}`,
  waitlistSection: "waitlist-section",
};

export const WAITLIST = {
  form: "waitlist-form",
  name: "waitlist-name",
  email: "waitlist-email",
  phone: "waitlist-phone",
  contactMethod: "waitlist-contact-method",
  services: "waitlist-services",
  timing: "waitlist-timing",
  submit: "waitlist-submit",
  successMessage: "waitlist-success",
};

export const FOOTER = {
  root: "footer-root",
  copyright: "footer-copyright",
  privacy: "footer-privacy-link",
  terms: "footer-terms-link",
};

export const LEGAL = {
  privacyPage: "privacy-page",
  termsPage: "terms-page",
  notice: "legal-placeholder-notice",
  returnHome: "legal-return-home",
};

export const NOTFOUND = {
  root: "notfound-page",
  eyebrow: "notfound-eyebrow",
  heading: "notfound-heading",
  returnHome: "notfound-return-home",
  book: "notfound-book-cta",
};

export const BLOG = {
  index: "blog-index",
  card: (slug) => `blog-card-${slug}`,
  post: "blog-post",
};
